import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { IconsMap } from "./IconsMap";
const Icon = ({ name, ...others }) => React.createElement(SvgIcon, { ...others }, IconsMap[name]);
export default Icon;
//# sourceMappingURL=Icon.js.map